// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","container":"styles_container__dbCk7","logo-link":"styles_logo-link__-DF-T","title":"styles_title__r3YGh","menu":"styles_menu__SD2UM"};